import { Tooltip, Typography } from '@mui/material';
import { formatDistanceToNowStrict } from 'date-fns';
import { formatDateFull } from '@/shared/lib';

interface Props {
  date: string;
}

export function RelativeTimestamp({ date }: Props) {
  return (
    <Tooltip arrow placement="right" title={formatDateFull(date)}>
      <Typography
        component="span"
        sx={{
          color: 'text.primary',
          textDecoration: 'underline',
          textDecorationStyle: 'dotted',
          fontSize: 'inherit',
        }}
      >
        {formatDistanceToNowStrict(date)} ago
      </Typography>
    </Tooltip>
  );
}
